<template>

	<div>
		<div class="orderList">
			<el-tabs v-model="listQuery.model" @tab-click="handleTabClick">
				<el-tab-pane :label="item.name" :name="item.id" v-for="(item, index) in tabList" :key="index">
					<div class="list">
						<el-form :inline="true" :model="listQuery" class="listSearchBar">
							<el-form-item label="状态">
								<el-select v-model="listQuery.status" placeholder="状态" size="small"
									style="width: 200px;" clearable @change="handleFilter">
									<el-option label="待支付" value="0"></el-option>
									<el-option label="待使用" value="10"></el-option>
									<el-option label="已使用" value="11"></el-option>
									<el-option label="待确认" value="20"></el-option>
									<el-option label="已确认" value="21"></el-option>
									<el-option label="待发货" value="30"></el-option>
									<el-option label="已发货" value="31"></el-option>
									<el-option label="退款中" value="90"></el-option>
									<el-option label="已退款" value="91"></el-option>
									<el-option label="退款失败" value="92"></el-option>
									<el-option label="已过期" value="99"></el-option>
									<el-option label="已取消" value="100"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="订单编号" label-width="120px">
								<el-input v-model="listQuery.keyword" size="small" placeholder="订单编号"
									style="width: 200px;" clearable @clear="handleFilter"></el-input>
							</el-form-item>
							<el-form-item label="下单时间" label-width="120px">
								<el-date-picker size="small" v-model="listQuery.createDate" style="width: 225px;"
									type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
									start-placeholder="开始日期" end-placeholder="结束日期" clearable @change="handleFilter">
								</el-date-picker>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" icon="el-icon-search" size="small"
									@click="handleFilter">查询</el-button>
							</el-form-item>
							<el-form-item>
								<el-button icon="el-icon-refresh-right" size="small" @click="handleReset">清空</el-button>
							</el-form-item>
						</el-form>
						<div v-loading="loading">
							<el-empty :image-size="100" v-if="list.length == 0"></el-empty>
							<div v-if="list.length > 0">
								<ul class="tableHeader tableGrid">
									<li>产品名称</li>
									<li>联系人</li>
									<li>订单信息</li>
									<li>订单状态</li>
									<li>数量</li>
									<li>订单总额</li>
									<li>备注</li>
									<li>操作</li>
								</ul>
								<div class="orders">
									<div class="listItem" v-for="(item, index) in list" :key="index">
										<div class="listItemHeader">
											<div class="infoItem">
												<div class="title">产品类型：</div>
												<div>{{ item.model_name }}</div>
											</div>
											<div class="infoItem">
												<div class="title">订单编号：</div>
												<div>{{ item.order_no }}</div>
											</div>
											<div class="infoItem">
												<div class="title">下单时间：</div>
												<div>{{ item.create_time }}</div>
											</div>
											<div class="infoItem" v-if="[4, 5].includes(item.status)">
												<div class="title">核销时间：</div>
												<div>{{ item.finish_time }}</div>
											</div>
										</div>
										<ul class="listItemBody tableGrid">
											<li>
												<p>{{ item.goods_name }}</p>
												<p v-if="item.goods_prop_id" class="fs13 color999 mgt5">规格：{{
				item.goods_prop_name }}</p>
											</li>
											<li>
												<p>{{ item.name }}</p>
												<p class="mgt5 mgb5">{{ formatPhone(item.phone) }}</p>
												<p>{{ formatIdcard(item.idcard) }}</p>
											</li>
											<li>
												<template v-if="item.model == 'ticket' || item.model == 'package'">
													<template v-if="item.goods_travel_type == 1">
														<p>游玩日期：{{ item.start_date }}~{{ item.end_date }}</p>
													</template>
													<template v-else>
														<p>游玩日期：{{ item.start_date }}</p>
													</template>
												</template>
												<template v-if="item.model == 'hotel'">
													<template v-if="item.goods_travel_type == 1">
														<p>有效期：{{ item.start_date }}~{{ item.end_date }}</p>
													</template>
													<template v-else>
														<p>入住：{{ item.start_date }}</p>
														<p>离店：{{ item.end_date }}</p>
													</template>
												</template>
												<template v-if="item.model == 'store'">
													<p class="mgb5">发货方式：{{ item.express_type_name }}</p>
													<p v-if="item.express_type == 1">地址：{{ item.fetch_address }}</p>
													<p v-else>地址：{{ item.address_province }}{{ item.address_city }}{{
				item.address_district }}{{ item.address_detail }}</p>
													<p v-if="item.express_name">物流公司：{{ item.express_name }}</p>
													<p v-if="item.express_no">物流单号：{{ item.express_no }}</p>
												</template>
											</li>

											<li class="flex-xy-center">
												<el-tag v-if="[0, 10, 11, 20, 21, 30, 31].includes(item.status)"
													effect="dark">{{ item.status_name }}</el-tag>
												<el-tag v-if="[90, 91, 92, 99, 100].includes(item.status)"
													type="info">{{
				item.status_name }}</el-tag>
											</li>
											<li class="flex-xy-center">
												<p class="mgb5">总数：{{ item.quantity }}</p>
												<p class="mgb5">已退：{{ item.refund_num }}</p>
												<p class="mgb5">使用：{{ item.used }}</p>
											</li>
											<li>
												<p class="mgb5">优惠：{{ formatPrice(item.coupon_amount) }}<el-tooltip
														v-if="item.coupon_name" class="item" effect="dark"
														:content="item.coupon_name" placement="top">
														<i class="fs16 mgl5 el-icon-question"></i>
													</el-tooltip> </p>
												<p v-if="!item.pay_time" class="mgb5">应付：{{
				formatPrice(item.pay_amount) }}</p>
												<p v-else class="mgb5">实付：{{ formatPrice(item.pay_amount)
													}}</p>
												<p v-if="item.refund_amount > 0" class="mgb5">退款：{{
				formatPrice(item.refund_amount) }}
												</p>
												<p :class="[item.payment_type == 1 ? 'colorGreen' : 'colorBlue']">
													{{
				item.payment_type_name }}</p>
											</li>
											<li>
												<p v-if="item.finish_time && item.model == 'package'">
													备注：已手工核销，出票信息请查看手机短信
												</p>
											</li>
											<li class="flex-xy-center">
												<el-button size="mini" class="btn" type="primary"
													v-if="item.status == 0" @click="handlePay(item)">付款</el-button>

												<el-button size="mini" class="btn mgt5" type="primary"
													v-if="item.status == 30 && item.express_type == 1"
													@click="handleFetch(item)">核销码</el-button>
												<el-button size="mini" class="btn mgt5" type="primary"
													v-if="item.pay_time" @click="handleDetail(item)">详情</el-button>
												<el-button size="mini" class="btn mgt5" type="primary" plain
													v-if="[0, 10, 20, 30].includes(item.status)"
													@click="handleCancel(item)">取消订单</el-button>
											</li>
										</ul>
									</div>
								</div>

								<el-pagination v-if="list.length > 0" style="text-align: center;margin-top: 40px;"
									background @size-change="handleSizeChange" @current-change="handleCurrentChange"
									:current-page="listQuery.page" :page-size="listQuery.pagesize"
									layout="prev, pager, next" :total="total">
								</el-pagination>
							</div>
						</div>

					</div>
				</el-tab-pane>
			</el-tabs>
		</div>
		<!-- 核销码弹窗 -->
		<order-fetch :oldOrder="oldOrder" :visible.sync="showFetchForm"></order-fetch>
	</div>
</template>

<script>
import { getOrderList, cancelOrder } from '@/api/order'
import OrderFetch from './components/orderFetch'

export default {
	name: 'TouristIndex',
	components: {
		OrderFetch
	},
	computed: {

	},
	data() {
		return {
			tabList: [
				{
					name: '全部',
					id: 'all'
				},
				{
					name: '景区门票',
					id: 'ticket'
				},
				{
					name: '酒店',
					id: 'hotel'
				},
				{
					name: '度假套餐',
					id: 'package'
				},
				{
					name: '风物文创',
					id: 'store'
				}
			],
			loading: false,
			list: [],
			total: 0,
			listQuery: {
				status: null,
				keyword: null,
				model: 'all',
				createDate: [],
				page: 1,
				pagesize: 10,
			},
			showFetchForm: false,
			oldOrder: {}
		}
	},
	created() {
		this.formatPrice = this.utils.formatPrice
		this.formatIdcard = this.utils.formatIdcard
		this.formatPhone = this.utils.formatPhone
		this.getList();
	},
	methods: {
		handleTabClick(tab, event) {
			this.handleFilter();
		},
		//去支付
		handlePay(item) {
			this.$router.push({
				name: 'orderPay',
				params: {
					id: item.id
				}
			});
		},
		//查看详情
		handleDetail(item) {
			this.$router.push({
				name: 'orderSuccess',
				params: {
					id: item.id
				}
			});
		},
		//查看核销码
		handleFetch(item) {
			this.oldOrder = item;
			this.showFetchForm = true;
		},
		// 取消订单
		handleCancel(order) {
			this.$confirm('确定要取消订单吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消'
			}).then(() => {
				this.loading = true;
				cancelOrder({
					id: order.id
				}).then((response) => {
					this.loading = false;
					this.getList();
					this.$message({
						type: 'success',
						message: '取消成功!'
					});
				}).catch(() => {
					this.loading = false;
				});
			});
		},
		// 获取列表
		getList() {
			this.loading = true;
			const _listQuery = Object.assign({}, this.listQuery);
			if (_listQuery.createDate) {
				_listQuery.start_time = _listQuery.createDate[0];
				_listQuery.end_time = _listQuery.createDate[1];
			}
			delete _listQuery.createDate;
			if (_listQuery.model == 'all') _listQuery.model = '';
			getOrderList(_listQuery)
				.then((response) => {
					this.list = response.data.list;
					this.total = response.data.count * 1;
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},
		// 查询
		handleFilter() {
			this.listQuery.page = 1;
			this.getList();
		},
		// 更改每页行数
		handleSizeChange(val) {
			this.listQuery.pagesize = val;
			this.getList();
		},
		// 更改页码
		handleCurrentChange(val) {
			this.listQuery.page = val;
			this.getList();
		},
		handleReset() {
			this.listQuery = {
				status: null,
				keyword: null,
				model: 'all',
				createDate: [],
				page: 1,
				pagesize: 10,
			};
		}
	}

}
</script>

<style lang="scss" scoped>
.orderList {
	width: 100%;
	font-size: 15px;

	.list {
		width: 100%;
		padding: 10px 16.5px 0 16.5px;
		box-sizing: border-box;

		.listSearchBar {
			margin: 0 auto;
		}

		.tableGrid {
			width: 100%;
			display: grid;
			grid-template-columns: 260fr 180fr 200fr 105fr 100fr 160fr 130fr 130fr;
		}

		.tableHeader {
			font-weight: 500;
			font-style: normal;
			color: #303133;
			text-align: center;
			padding: 15px 0;
			background-color: #f7f7f7f7;
			width: 100%;
		}

		.orders {
			width: 100%;
			display: flex;
			align-items: center;
			flex-direction: column;
			row-gap: 18px;
			margin-top: 20px;

			.listItem {
				width: 100%;
				border: 1px solid rgba(235, 238, 245, 1);

				&>ul {
					border-bottom: 1px solid rgba(235, 238, 245, 1);
				}

				ul:last-child {
					border-bottom: none;
				}

				.listItemHeader {
					width: 100%;
					padding: 15px;
					box-sizing: border-box;
					display: flex;
					align-items: center;
					column-gap: 25px;
					background-color: #f7f7f7f7;

					.infoItem {
						display: flex;
						align-items: center;
						column-gap: 5px;
						font-weight: 400;
						font-style: normal;
						color: #303133;

						.title {
							font-weight: 400;
							font-style: normal;
							color: #909399;
						}
					}
				}

				.listItemBody {
					li {
						width: 100%;
						padding: 20px 10px;
						display: flex;
						flex-direction: column;
						line-height: 1.3;
						justify-content: center;
						border-right: 1px solid rgba(235, 238, 245, 1);
						box-sizing: border-box;

						.el-tag {
							width: fit-content;
						}
					}

					li:last-child {
						border-right: none;
					}

					// li:last-child,li:nth-last-child(2),li:nth-last-child(3){
					// 	border-right: none;
					// }
				}
			}
		}

		.btn {
			width: 80px;
			margin-left: 0;
		}
	}
}
</style>
